import script from "./Portfolio.vue?vue&type=script&setup=true&lang=ts"
export * from "./Portfolio.vue?vue&type=script&setup=true&lang=ts"

import "./Portfolio.vue?vue&type=style&index=0&id=7cadc20e&lang=scss"

const __exports__ = script;

export default __exports__